"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WINDOW_BREAKPOINT_LG = exports.DATA_SPLIDE_CAROUSEL = exports.DATA_BUTTON_TO_TOP = exports.DATA_FOOTER_SECOND = exports.DATA_FOOTER_FIRST = exports.DATA_FOOTER = exports.DATA_DROPDOWN_MENU = exports.DATA_DROPDOWN = exports.DATA_HEADER = void 0;
exports.DATA_HEADER = 'data-header';
exports.DATA_DROPDOWN = 'data-dropdown';
exports.DATA_DROPDOWN_MENU = 'data-dropdown-menu';
exports.DATA_FOOTER = 'data-footer';
exports.DATA_FOOTER_FIRST = 'data-footer-first';
exports.DATA_FOOTER_SECOND = 'data-footer-second';
exports.DATA_BUTTON_TO_TOP = 'data-button-to-top';
exports.DATA_SPLIDE_CAROUSEL = 'data-splide-carousel';
exports.WINDOW_BREAKPOINT_LG = 992;
